export const productColGrow = 2;
export const inputColGrow = 0;
export const inputColBasis = 120;
export const editHeaderColBasis = 46;
export const editColBasis = 24;
export const actionsColBasis = 96;
export const inputColVariant = 250;
